import React, { Fragment } from 'react';
import { Container } from 'react-bootstrap';
import HeaderLogged from '../../../../components/header_logged'
import Footer from '../../../../components/footer'
import Head from '../../../../components/head';
import TerceirizadosLogged from '../../../../components/auth/rh/terceirizados'

function TerceirizadosLoggedScreen() {
        return (
            <Fragment>
                <Head titulo="Módulo de Estagiários - Recursos Humanos" />
                <HeaderLogged />
                <Container>
                   <TerceirizadosLogged />
                </Container>
                <Footer />
            </Fragment>
        );
}

export default TerceirizadosLoggedScreen;